import { lazy } from "react";

// project imports
import Loadable from "../components/molecules/Berry/Loadable";
import OrganizationGuard from "../components/atoms/route-guard/OrganizationGuard";
import { Outlet } from "react-router-dom";

// dashboard routing
const OrganizationDiagramPage = Loadable(
  lazy(() => import("../components/pages/organizationDiagramPage"))
);
const NotAllowedPage = Loadable(
  lazy(() => import("../components/pages/notAllowedPage"))
);
const Error = Loadable(lazy(() => import("../components/pages/errorPage")));
// ==============================|| MAIN ROUTING ||============================== //

const OrganizaciaRoutes = {
  path: "/",
  element: (
    <OrganizationGuard>
      <Outlet />
    </OrganizationGuard>
  ),
  children: [
    {
      path: "/app/organizacny-diagram",
      element: <OrganizationDiagramPage />,
    },
    {
      path: "/app/not-allowed",
      element: <NotAllowedPage />,
    },
    {
      path: "/app/error",
      element: <Error />,
    },
    {
      path: "*",
      element: <Error />,
    },
  ],
};

export default OrganizaciaRoutes;
